function checkDuplicatedUUIDS(root) {
    const uuids = new Set();
    function traverseMetadataTree(node) {
        const { uuid } = node.props;
        if (!uuids.has(uuid)) {
            uuids.add(uuid);
        }
        else {
            throw new Error(`[TWS-ENGINE]: Found duplicated UUID: ${uuid}`);
        }
        if (node.children) {
            node.children.forEach(traverseMetadataTree);
        }
    }
    traverseMetadataTree(root);
}
export { checkDuplicatedUUIDS, };
//# sourceMappingURL=check-duplicated-uuids.js.map